import 'autotrack'

export default function() {
  ga('create', process.env.VUE_APP_GOOGLE_ANALYTICS_KEY, 'auto')

  ga('require', 'urlChangeTracker')

  ga('send', 'pageview')
}
